import { tauriMode } from '@/shared/utils/import-meta'

export const RINGTONE_CALL_ENDED = '/ringtones/call-ended.wav'

const sourceMap = new Map<string, Promise<AudioBuffer>>()
let contextInstance: AudioContext
const getContextInstance = () => {
  if (!contextInstance) {
    contextInstance = new AudioContext()
  }
  return contextInstance
}

export interface AudioPlayer {
  play: () => void
}

export const usePlayAudio = (relativePath: string) => {
  if (!sourceMap.has(relativePath)) {
    if (tauriMode()) {
      initTauriSource(relativePath)
    } else {
      initWebSource(relativePath)
    }
  }

  const play = () => {
    const context = getContextInstance()
    const source = context.createBufferSource()
    sourceMap.get(relativePath)?.then((buffer) => {
      source.buffer = buffer
      source.loop = false
      source.connect(context.destination)
      source.start()
    }).catch((e) => console.error(e))
  }

  return {
    play,
  }
}

const initTauriSource = async (relativePath: string) => {
  const { path } = await import('@tauri-apps/api')
  sourceMap.set(relativePath, path.resolveResource('../dist' + relativePath)
    .then(async (path) => {
      const { readFile } = await import('@tauri-apps/plugin-fs')
      return readFile(path)
    })
    .then((res) => {
      return res.buffer
    })
    .then((arrayBuffer) => {
      const x = getContextInstance().decodeAudioData(<ArrayBuffer>arrayBuffer)
      return x
    }))
}

const initWebSource = (relativePath: string) => {
  sourceMap.set(relativePath, fetch(relativePath)
    .then((res) => res.arrayBuffer())
    .then((arrayBuffer) => getContextInstance().decodeAudioData(arrayBuffer)))
}
